import type { ComponentPropsWithRef } from "react"
import { cn } from "@/lib/cn"

// Single-line text input. Keeps the dark-surface look — every form on the
// portal pulls this rather than styling raw <input>s ad-hoc.
type Props = ComponentPropsWithRef<"input">

// `min-h-11` (44 px) clears the WCAG touch-target minimum so single-handed
// thumb taps land reliably on phones without making forms feel oversized
// on desktop. `rounded-xl` matches the design prototype. We don't default
// to `w-full` because many existing layouts size the input via the parent
// (search inputs in flex rows, inline edit cells) — pages adopting the
// new look pass `className="w-full"` explicitly.
export function Input({ className, ref, ...rest }: Props) {
  return (
    <input
      ref={ref}
      {...rest}
      className={cn(
        "min-h-11 rounded-xl border border-border bg-white/5 px-4 text-sm text-app-text",
        "placeholder:text-app-subtle outline-none transition focus:border-brand-red/50 focus:shadow-[0_0_0_3px_var(--brand-red-soft)]",
        "disabled:opacity-50 disabled:pointer-events-none",
        className,
      )}
    />
  )
}
